var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path === '/')?[_c('HomeLayout',[_c('router-view')],1)]:(_vm.$route.meta.requiresAuth)?[_c('AuthorizeLayout',[_c('router-view')],1)]:[_c('DefaultLayout',[_c('router-view')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }